<template>
  <a-spin :spinning="spinning" tip="加载中...">
    <div class="top-title" @click="lastStep"><a-icon type="left" /> 电梯信息</div>
    <div class="card-value-class">
      <a-row :gutter="[0, 15]">
        <a-col :span="24">
          <a-card :bordered="false">
            <div class="title-div">
              <img height="14" src="~@/assets/image/nationalStandard.png" alt=""/>
            </div>
            <div class="m-list">
              <div class="m-list-col">
                <a-row :gutter="[0, 10]">
                  <a-col :span="24">
                    <div class="m-list-con">
                      <div class="div1">
                        保障期限
                      </div>
                      <div class="div2">
                        {{ record.insuranceBeginTime?$moment(new Date(record.insuranceBeginTime)).format('YYYY-MM-DD'):'-' }} ~ {{ record.insuranceEndTime?$moment(new Date(record.insuranceEndTime)).format('YYYY-MM-DD'):'-' }}
                      </div>
                    </div>
                  </a-col>
                  <a-col :span="24">
                    <div class="m-list-con">
                      <div class="div1">
                        承保单位
                      </div>
                      <div class="div2">
                        {{ record.insurerOrgName ? record.insurerOrgName : '' }}
                      </div>
                    </div>
                  </a-col>
                  <a-col :span="24">
                    <div class="m-list-con">
                      <div class="div1">
                        保险工程师
                      </div>
                      <div class="div2">
                        {{ record.insurerName }}
                      </div>
                    </div>
                  </a-col>
                  <a-col :span="24">
                    <a-divider />
                  </a-col>
                  <a-col :span="24">
                    <div class="m-list-con">
                      <div class="div1">
                        投保人
                      </div>
                      <div class="div2">
                        {{ record.applicant }}
                      </div>
                    </div>
                  </a-col>
                  <a-col :span="24">
                    <div class="m-list-con">
                      <div class="div1">
                        保单编号
                      </div>
                      <div class="div2">
                        {{ record.insuranceNo }}
                      </div>
                    </div>
                  </a-col>
                  <a-col :span="24">
                    <div class="m-list-con">
                      <div class="div1">
                        被保险人
                      </div>
                      <div class="div2">
                        {{ record.insuredOrgName }}
                      </div>
                    </div>
                  </a-col>
                </a-row>
              </div>
            </div>
          </a-card>
        </a-col>
        <a-col :span="24">
          <div class="all-card">
            <a-card :bordered="false">
              <div class="title-div">
                电梯信息
              </div>
              <div class="m-list">
                <div class="m-list-col">
                  <a-row :gutter="[0, 10]">
                    <a-col :span="24">
                      <div class="m-list-con">
                        <div class="div1">
                          电梯编号
                        </div>
                        <div class="div2">
                          {{ record.no }}
                        </div>
                      </div>
                    </a-col>
                    <a-col :span="24">
                      <div class="m-list-con">
                        <div class="div1">电梯类型</div>
                        <div class="div2">
                          <span v-if=" record.type == 3100">曳引与强制驱动电梯</span>
                          <span v-if=" record.type == 3300">自动扶梯与自动人行道</span>
                        </div>
                      </div>
                    </a-col>
                    <a-col :span="24">
                      <div class="m-list-con">
                        <div class="div1">电梯地址</div>
                        <div class="div2">
                          {{addressOrNumm(record.cityName == '市辖区' || record.cityName == '县' ? record.provinceName : record.cityName) }}
                          {{ addressOrNumm(record.countyName) }}
                        </div>
                      </div>
                    </a-col>
                    <a-col :span="24">
                      <div class="m-list-con">
                        <div class="div1">使用场所</div>
                        <div class="div2">
                          {{ addressOrNumm(record.communityName) }}
                          {{ addressOrNumm(record.buildingName) }}
                          {{ addressOrNumm(record.unitName) }}
                          {{ addressOrNumm(record.positionInUnit) }}
                        </div>
                      </div>
                    </a-col>
                    <a-col :span="24">
                      <div class="m-list-con">
                        <div class="div1">注册代码</div>
                        <div class="div2">
                          {{ record.registerNo ? record.registerNo : '' }}
                        </div>
                      </div>
                    </a-col>
                  </a-row>
                </div>
              </div>
            </a-card>
            <a-divider />
            <a-card :bordered="false">
              <div class="title-div">
                管理单位
              </div>
              <div class="m-list">
                <div class="m-list-col">
                  <a-row :gutter="[0, 10]">
                    <a-col :span="24">
                      <div class="m-list-con">
                        <div class="div1">
                          使用单位
                        </div>
                        <div class="div2">
                          {{ record.mgtOrgName ? record.mgtOrgName : '' }}
                        </div>
                      </div>
                    </a-col>
                    <a-col :span="24">
                      <div class="m-list-con">
                        <div class="div1">
                          物业单位
                        </div>
                        <div class="div2">
                          {{ record.userOrgName ? record.userOrgName : '' }}
                        </div>
                      </div>
                    </a-col>
<!--                    <a-col :span="24">
                      <div class="m-list-con">
                        <div class="div1">
                          安全管理员
                        </div>
                        <div class="div2">

                        </div>
                      </div>
                    </a-col>-->
                    <a-col :span="24">
                      <div class="m-list-con">
                        <div class="div1">
                          维保单位
                        </div>
                        <div class="div2">
                          {{ record.maintainerOrgName ? record.maintainerOrgName : '' }}
                        </div>
                      </div>
                    </a-col>
                    <a-col :span="24">
                      <div class="m-list-con">
                        <div class="div1">
                          维保人员
                        </div>
                        <div class="div2">
                          {{ record.maintainerName ? record.maintainerName : '' }}
                        </div>
                      </div>
                    </a-col>
<!--                    <a-col :span="24">
                      <div class="m-list-con">
                        <div class="div1">
                          安装单位
                        </div>
                        <div class="div2">
                          {{ record.installerOrgName ? record.installerOrgName : '-' }}
                        </div>
                      </div>
                    </a-col>
                    <a-col :span="24">
                      <div class="m-list-con">
                        <div class="div1">投用时间</div>
                        <div class="div2">
                          <span v-if="record.beginUseTime">{{ formatDate2(record.beginUseTime)}}</span>
                          <span v-else>-</span>
                        </div>
                      </div>
                    </a-col>
                    <a-col :span="24">
                      <div class="m-list-con">
                        <div class="div1">注册代码</div>
                        <div class="div2">
                          {{ record.registerNo ? record.registerNo : '-' }}
                        </div>
                      </div>
                    </a-col>
                    <a-col :span="24">
                      <div class="m-list-con">
                        <div class="div1">制造单位</div>
                        <div class="div2">
                          {{ record.producerOrgName ? record.producerOrgName : '-' }}
                        </div>
                      </div>
                    </a-col>
                    <a-col :span="24">
                      <div class="m-list-con">
                        <div class="div1">生产日期</div>
                        <div class="div2">
                          <span v-if="record.produceTime">{{ formatDate2(record.produceTime) }}</span>
                          <span v-else>-</span>
                        </div>
                      </div>
                    </a-col>
                    <a-col :span="24">
                      <div class="m-list-con">
                        <div class="div1">出厂编号</div>
                        <div class="div2">
                          {{ record.produceNo ? record.produceNo : '-' }}
                        </div>
                      </div>
                    </a-col>
                    <a-col :span="24">
                      <div class="m-list-con">
                        <div class="div1">电梯型号</div>
                        <div class="div2">
                          {{ record.model ? record.model : '-' }}
                        </div>
                      </div>
                    </a-col>
                    <a-col :span="24">
                      <div class="m-list-con">
                        <div class="div1">使用登记证</div>
                        <div class="div2">
                          {{ record.useNo ? record.useNo : '-' }}
                        </div>
                      </div>
                    </a-col>-->
                  </a-row>
                </div>
              </div>
            </a-card>
            <a-divider />
            <a-card :bordered="false">
              <div class="title-div">
                维保情况
              </div>
              <div class="m-list">
                <div class="m-list-col">
                  <a-row :gutter="[0, 10]">
                    <a-col :span="24">
                      <div class="m-list-con">
                        <div class="div1">
                          上次维保时间
                        </div>
                        <div class="div2">
                          {{ record.lastMaintainTime ? formatDate2(record.lastMaintainTime) : '' }}
                          <a v-if="record.lastMaintainTime" @click="gotoMiantain">查看</a>
                        </div>
                      </div>
                    </a-col>
                    <a-col :span="24">
                      <div class="m-list-con">
                        <div class="div1">
                          维保人员
                        </div>
                        <div class="div2">
                          {{ record.maintainerName ? record.maintainerName : '' }}
                        </div>
                      </div>
                    </a-col>
                    <a-col :span="24">
                      <div class="m-list-con">
                        <div class="div1">
                          维保单位
                        </div>
                        <div class="div2">
                          {{ record.lastMaintainOrgName ? record.lastMaintainOrgName : '' }}
                        </div>
                      </div>
                    </a-col>
                    <a-col :span="24">
                      <div class="m-list-con">
                        <div class="div1">
                          下次维保时间
                        </div>
                        <div class="div2">
                          {{ record.nextMaintainTime ? formatDate2(record.nextMaintainTime) : '' }}
                        </div>
                      </div>
                    </a-col>
                  </a-row>
                </div>
              </div>
            </a-card>
            <a-divider />
            <a-card :bordered="false">
              <div class="title-div">
                维修情况
              </div>
              <div class="m-list">
                <div class="m-list-col">
                  <a-row :gutter="[0, 10]">
                    <a-col :span="24">
                      <div class="m-list-con">
                        <div class="div1">
                          上次维修时间
                        </div>
                        <div class="div2">
                          {{ record.lastRepairTime ? formatDate2(record.lastRepairTime) : '' }}
                          <a v-if="record.lastRepairTime" @click="gotoRepair">查看</a>
                        </div>
                      </div>
                    </a-col>
                    <a-col :span="24">
                      <div class="m-list-con">
                        <div class="div1">
                          维修类型
                        </div>
                        <div class="div2">
                          <span v-if="record.repairType == 1">免费维修</span>
                          <span v-if="record.repairType == 2">免费部件更换</span>
                          <span v-if="record.repairType == 11">收费维修</span>
                          <span v-if="record.repairType == 12">收费部件更换</span>
                        </div>
                      </div>
                    </a-col>
                    <a-col :span="24">
                      <div class="m-list-con">
                        <div class="div1">
                          维修人员
                        </div>
                        <div class="div2">
                          {{ record.repairer }}
                        </div>
                      </div>
                    </a-col>
                    <a-col :span="24">
                      <div class="m-list-con">
                        <div class="div1">
                          维修单位
                        </div>
                        <div class="div2">
                          {{ record.lastRepairOrgName ? record.lastRepairOrgName : '' }}
                        </div>
                      </div>
                    </a-col>
                  </a-row>
                </div>
              </div>
            </a-card>
          </div>
        </a-col>
      </a-row>
    </div>
  </a-spin>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      record: {},
      spinning:false,
      elevatortypes:[]
    };
  },
  watch: {
    '$route.query': {
      immediate: true,
      handler(newQuery) {
        // 这里处理 query 参数变化的逻辑
        this.record = JSON.parse(newQuery.record)
      }
    }
  },
  created() {
    this.record = JSON.parse(this.$route.query.record)
  },
  methods: {
    lastStep(){
      this.$router.back(-1); // 后退到上一页
    },
    gotoMiantain(){
      this.$router.push({ path: 'maintain', query: { record: JSON.stringify(this.record) } });
    },
    gotoRepair(){
      this.$router.push({ path: 'repair', query: { record: JSON.stringify(this.record) } });
    },
    addressOrNumm(value){
      if (value) {
        return value
      } else {
        return ''
      }
    },
    // 时间戳转换
    formatDate(timeStamp) {
      let time = new Date(Number(timeStamp)),
        y = time.getFullYear(),
        m = time.getMonth() + 1,
        d = time.getDate(),
        h = time.getHours(),
        mm = time.getMinutes(),
        s = time.getSeconds();
      return y + '-' + this.addZero(m) + '-' + this.addZero(d) + ' ' + this.addZero(h) + ':' + this
        .addZero(mm) + ':' + this.addZero(s);
    },
    formatDate2(timeStamp) {
      let time = new Date(Number(timeStamp)),
        y = time.getFullYear(),
        m = time.getMonth() + 1,
        d = time.getDate(),
        h = time.getHours(),
        mm = time.getMinutes(),
        s = time.getSeconds();
      return y + '-' + this.addZero(m) + '-' + this.addZero(d);
    },
    addZero(num) {
      if (num < 10) return '0' + num;
      return num;
    },
  }
};
</script>

<style lang="less" scoped>
.m-list {
  width: 100%;
  height: auto;
}

.m-list-col {
  width: 100%;
}

.m-list-con {
  color: #333333;
  display: flex;
}

.div1 {
  font-size: 14px;
  font-weight: 400;
  flex-shrink: 0;
  color: #999999;
}
.div2 {
  font-size: 14px;
  font-weight: 400;
  flex: 1;
  padding-left:15px;
  text-align: right;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.elev-title {
  font-size: 16px;
  color: #000000;
  font-weight: bold;
}

.card-div {
  font-weight: bold;
  font-family: PingFangSC-Regular, PingFang SC;
}
/deep/ .ant-card {
  border-radius: 10px;
}
/deep/ .ant-card-body {
  padding: 15px;
  zoom: 1;
}
/deep/ .ant-divider-horizontal {
  display: block;
  clear: both;
  width: 100%;
  min-width: 100%;
  height: 1px;
  margin: 0px 0;
}
.title-div {
  font-size: 16px;
  font-family: PingFangSC, PingFang SC;
  color: #333333;
  padding-bottom: 10px;
}
.all-card{
  background: #FFFFFF;
  border-radius: 10px;
}
.top-title{
  background: #FFFFFF;
  width: 100%;
  height: 60px;
  line-height: 60px;
  font-size: 18px;
  color: #333333;
  padding: 0 10px;
  margin-bottom: 15px;
  cursor: pointer;
}
.card-value-class{
  margin: 0px 15px;
}
a{
  color: #ff4d4f;
  padding-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/elevator.vue